/**
 * @file store main
 * @author wangzhongpeng
 */

import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import WindFarm from './modules/wind-farm';
import model from './modules/model';
import WindData from './modules/wind-data.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
     WindFarm,
     model,
     WindData
  },
  state,
  getters,
  mutations,
  actions
});
